export const zones = [
	 {
    "eng": "Europe/Kaliningrad",
    "ru": "Калининград"
  },
  {
    "eng": "Europe/Moscow",
    "ru": "Москва"
  },
  {
    "eng": "Europe/Simferopol",
    "ru": "Симферополь"
  },
  {
    "eng": "Europe/Kirov",
    "ru": "Киров"
  },
  {
    "eng": "Europe/Volgograd",
    "ru": "Волгоград"
  },
  {
    "eng": "Europe/Astrakhan",
    "ru": "Астрахань"
  },
  {
    "eng": "Europe/Saratov",
    "ru": "Саратов"
  },
  {
    "eng": "Europe/Ulyanovsk",
    "ru": "Ульяновск"
  },
  {
    "eng": "Europe/Samara",
    "ru": "Самара"
  },
  {
    "eng": "Asia/Yekaterinburg",
    "ru": "Екатеринбург"
  },
  {
    "eng": "Asia/Omsk",
    "ru": "Омск"
  },
  {
    "eng": "Asia/Novosibirsk",
    "ru": "Новосибирск"
  },
  {
    "eng": "Asia/Barnaul",
    "ru": "Барнаул"
  },
  {
    "eng": "Asia/Tomsk",
    "ru": "Томск"
  },
  {
    "eng": "Asia/Novokuznetsk",
    "ru": "Новокузнецк"
  },
  {
    "eng": "Asia/Krasnoyarsk",
    "ru": "Красноярск"
  },
  {
    "eng": "Asia/Irkutsk",
    "ru": "Иркутск"
  },
  {
    "eng": "Asia/Chita",
    "ru": "Чита"
  },
  {
    "eng": "Asia/Yakutsk",
    "ru": "Якутск"
  },
  {
    "eng": "Asia/Khandyga",
    "ru": "Хандыга"
  },
  {
    "eng": "Asia/Vladivostok",
    "ru": "Владивосток"
  },
  {
    "eng": "Asia/Ust-Nera",
    "ru": "Усть-Нера"
  },
  {
    "eng": "Asia/Magadan",
    "ru": "Магадан"
  },
  {
    "eng": "Asia/Sakhalin",
    "ru": "Сахалин"
  },
  {
    "eng": "Asia/Srednekolymsk",
    "ru": "Среднеколымск"
  },
  {
    "eng": "Asia/Kamchatka",
    "ru": "Камчатка"
  },
  {
    "eng": "Asia/Anadyr",
    "ru": "Анадырь"
  },
	{
		"eng": "Asia/Ufa",
		"ru": "Уфа"
	}
];
export const timezoneGroups = [
  {
    name: "МСК -1",
    offset: -1,
    zones: [
      {
        "eng": "Europe/Kaliningrad",
        "ru": "Калининград"
      }
    ]
  },
  {
    name: "МСК",
    offset: 0,
    zones: [
      {
        "eng": "Europe/Moscow",
        "ru": "Москва"
      },
      {
        "eng": "Europe/Simferopol",
        "ru": "Симферополь"
      },
			{
        "eng": "Europe/Volgograd",
        "ru": "Волгоград"
      },
			{
        "eng": "Europe/Kirov",
        "ru": "Киров"
      },
    ]
  },
  {
    name: "МСК +1",
    offset: 1,
    zones: [
      {
        "eng": "Europe/Astrakhan",
        "ru": "Астрахань"
      },
      {
        "eng": "Europe/Saratov",
        "ru": "Саратов"
      },
      {
        "eng": "Europe/Ulyanovsk",
        "ru": "Ульяновск"
      },
      {
        "eng": "Europe/Samara",
        "ru": "Самара"
      },
      {
        "eng": "Asia/Ufa",
        "ru": "Уфа"
      }
    ]
  },
  {
    name: "МСК +2",
    offset: 2,
    zones: [
      {
        "eng": "Asia/Yekaterinburg",
        "ru": "Екатеринбург"
      }
    ]
  },
  {
    name: "МСК +3",
    offset: 3,
    zones: [
      {
        "eng": "Asia/Omsk",
        "ru": "Омск"
      }
    ]
  },
  {
    name: "МСК +4",
    offset: 4,
    zones: [
      {
        "eng": "Asia/Novosibirsk",
        "ru": "Новосибирск"
      },
      {
        "eng": "Asia/Barnaul",
        "ru": "Барнаул"
      },
      {
        "eng": "Asia/Tomsk",
        "ru": "Томск"
      },
      {
        "eng": "Asia/Novokuznetsk",
        "ru": "Новокузнецк"
      },
      {
        "eng": "Asia/Krasnoyarsk",
        "ru": "Красноярск"
      }
    ]
  },
  {
    name: "МСК +5",
    offset: 5,
    zones: [
      {
        "eng": "Asia/Irkutsk",
        "ru": "Иркутск"
      }
    ]
  },
  {
    name: "МСК +6",
    offset: 6,
    zones: [
      {
        "eng": "Asia/Chita",
        "ru": "Чита"
      },
      {
        "eng": "Asia/Khandyga",
        "ru": "Хандыга"
      },
      {
        "eng": "Asia/Yakutsk",
        "ru": "Якутск"
      }
    ]
  },
  {
    name: "МСК +7",
    offset: 7,
    zones: [
      {
        "eng": "Asia/Vladivostok",
        "ru": "Владивосток"
      },
      {
        "eng": "Asia/Ust-Nera",
        "ru": "Усть-Нера"
      }
    ]
  },
  {
    name: "МСК +8",
    offset: 8,
    zones: [
			{
        "eng": "Asia/Sakhalin",
        "ru": "Сахалин"
      },
      {
        "eng": "Asia/Magadan",
        "ru": "Магадан"
      },
      {
        "eng": "Asia/Srednekolymsk",
        "ru": "Среднеколымск"
      }
    ]
  },
  {
    name: "МСК +9",
    offset: 9,
    zones: [
			 {
        "eng": "Asia/Anadyr",
        "ru": "Анадырь"
      },
			{
        "eng": "Asia/Kamchatka",
        "ru": "Камчатка"
      }
    ]
  },
  {
    name: "МСК +10",
    offset: 10,
    zones: [
      
    ]
  }
];